<template>
	<div class="setting">
		<MyForm ref="myForm" width="800px" label-width="115px" v-model:list="formProps" :form="form" :rules="rules"
			:loading="formLoading" :mode="mode" :inline="true">
			<!-- <template #password2 >
			<el-input v-model="form.password2" placeholder="请输入密码" style="width: 220px"></el-input>
		</template> -->
		</MyForm>
		<div class="footer">
			<div class="submit-box">
				<el-button type="primary" @click="onSubmit">提交</el-button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue'
import MyForm from '@/components/common/proForm'
import { editUserInfo } from '@/api/common.js'
import { useMixins } from './minixs/setting.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import md5 from 'js-md5'


const { formProps, rules, showPassword } = useMixins()

// Props
const props = defineProps({
	info: {
		type: Object
	}
})

// Reactive data
const myForm = ref(null)
const mode = ref('DESIGN')
const saving = ref(false)
const formLoading = ref(false)
const form = ref({})

// Watch
watch(
	() => props.info,
	(outside_prop_new) => {
		form.value = []
		form.value = JSON.parse(JSON.stringify(outside_prop_new))

		nextTick(() => {
			showPassword.value = form.value.is_default_pass == 1 ? true : false
		})

	},
	{ deep: true, immediate: true }
)

// Methods
const onSubmit = () => {
	myForm.value.formRef.validate(async (valid) => {
		if (valid) {
			form.value.avatar_url = form.value.pic_l[0].url
			form.value.wechat_url = form.value.pic_w[0].url
			// form.value.promote_url = form.value.promote_url
			if (form.value.password2 && form.value.password2 != '') {
				form.value.password = md5(form.value.password2 + localStorage.getItem('salt'))
			}
			const res = await editUserInfo(form.value)
			if (res.code == 200) {
				ElMessage({
					type: 'success',
					message: res.msg
				})
			} else {
				ElMessage({
					type: 'warning',
					message: '保存失败请稍后重试'
				})
			}
		}
	})
}
</script>
<style scoped lang="scss">
.footer {
	background-color: #fff;
	width: 100%;

	.submit-box {
		float: right;
	}
}
</style>
